module.exports = __webpack_public_path__ + "edccf47fae0a235dc68a31a2ba346099.svg";